module.exports = "<button class=\"kd-icon kd-icon--light\"\r\n    type=\"button\"\r\n    ng-click=\"$ctrl.sync()\">\r\n  <i class=\"fa fa-lg fa-refresh\" ng-class=\"{'fa-spin': $ctrl.processing}\"></i>\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/app/sync/template.html
// module id = 2707
// module chunks = 0